// extracted by mini-css-extract-plugin
export default {"section":"NewsHeadline_section__wBsTN","question":"NewsHeadline_question__Hd69q","paragraph":"NewsHeadline_paragraph__zUJpu"};